import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=c1071a2e&scoped=true&"
import script from "./Camera.vue?vue&type=script&lang=ts&"
export * from "./Camera.vue?vue&type=script&lang=ts&"
import style0 from "./Camera.vue?vue&type=style&index=0&id=c1071a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1071a2e",
  null
  
)

export default component.exports